// extracted by mini-css-extract-plugin
export default {"App":"App_App__64aVz","mainMenu":"App_mainMenu__CHm4U","language":"App_language__ZQ2G0"};